import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { ApiError } from '@/lib/api/error';
import { getLogsheetDetailViewRequest } from '@/services/logsheet-view';
import type { LogsheetDetailView } from '@/types/logsheet-view';

/**
 * Loads the unified read-only detail for a logsheet entry.
 *
 * Same `staleTime: 5_000` cadence as the legacy maker / approver detail hooks
 * so a queue → detail → action → back round-trip refetches the latest server
 * state without spamming the endpoint on transient re-renders.
 */
export function useLogsheetDetailViewQuery(id: number): UseQueryResult<LogsheetDetailView, ApiError> {
  return useQuery<LogsheetDetailView, ApiError>({
    queryKey: ['logsheet-view', id],
    queryFn: () => getLogsheetDetailViewRequest(id),
    enabled: Number.isFinite(id) && id > 0,
    staleTime: 5_000,
  });
}
